import {connect} from "react-redux";
import ApprovalAddressDsmLead from "./ApprovalAction";
import {bindActionCreators} from "redux";
import {getLeadAddressPendingByIdRequest, leadAddressApprovalActionRequest} from "../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    leadById:state.Lead.getLeadAddressPendingByIdResponse,
    leadApprovalResponse:state.Lead.leadAddressApprovalActionResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getLeadAddressPendingByIdRequest,
            leadAddressApprovalActionRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ApprovalAddressDsmLead);
